import { render, staticRenderFns } from "./OrderStatusTracker.vue?vue&type=template&id=c0220daa"
import script from "./OrderStatusTracker.vue?vue&type=script&lang=js"
export * from "./OrderStatusTracker.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusTracker.vue?vue&type=style&index=0&id=c0220daa&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports